function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0zm6.891 9.973-7.539 7.539a1.7 1.7 0 0 1-2.4 0L5.109 13.67a1.7 1.7 0 1 1 2.4-2.4l2.642 2.642 6.339-6.339a1.7 1.7 0 0 1 2.4 2.4z",
    style: {
      fill: "#10a630"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickActive);
export default __webpack_public_path__ + "static/media/greenTickActive.97f121504c1d3fa1a3622e3ded29c7e2.svg";
export { ForwardRef as ReactComponent };